import { useCampaignSlug } from '@/core/app/useCampaignSlug'

export const useUserDeviceUuid = (): { uuid: string } => {
  const { LOCAL_STORAGE_USER_DEVICE_UUID_KEY } = useCampaignSlug()
  if (typeof window === 'undefined') {
    return { uuid: crypto.randomUUID() }
  }
  const uuidFromLocalStorage = localStorage.getItem(LOCAL_STORAGE_USER_DEVICE_UUID_KEY)
  if (uuidFromLocalStorage) {
    return { uuid: uuidFromLocalStorage }
  }
  const uuid = crypto.randomUUID()
  localStorage.setItem(LOCAL_STORAGE_USER_DEVICE_UUID_KEY, uuid)
  return { uuid }
}
